import React from "react";
import { FaChartLine, FaUsers, FaDollarSign, FaShoppingCart, FaBox, FaDatabase } from "react-icons/fa";

const Card = ({ title, count, icon: Icon, textColor, bgGradient }) => {
  // Default gradient if none provided
  const gradient = bgGradient || "from-white to-primary/20";
  // Default text color if none provided
  const txtColor = textColor || "text-black";

  // Function to determine the best default icon based on title
  const getDefaultIcon = (title) => {
    if (!title) return FaChartLine; // Fallback icon

    const lowerTitle = title.toLowerCase();

    if (lowerTitle.includes('user') || lowerTitle.includes('customer')) {
      return FaUsers;
    }
    if (lowerTitle.includes('sale') || lowerTitle.includes('revenue') || lowerTitle.includes('price')) {
      return FaDollarSign;
    }
    if (lowerTitle.includes('order') || lowerTitle.includes('cart')) {
      return FaShoppingCart;
    }
    if (lowerTitle.includes('product') || lowerTitle.includes('inventory') || lowerTitle.includes('stock')) {
      return FaBox;
    }
    if (lowerTitle.includes('data') || lowerTitle.includes('metric')) {
      return FaDatabase;
    }

    return FaChartLine; // Default general-purpose icon
  };

  // Use provided icon or get a default one
  const DisplayIcon = Icon || getDefaultIcon(title);

  return (
    <div
      className={`
        flex justify-between items-center 
        p-5 rounded-xl shadow-lg
        bg-gradient-to-r ${gradient}
        transition-all duration-300
        hover:shadow-xl hover:scale-[1.02]
      `}
    >
      <div className="flex-1">
        <h3 className={`text-sm font-medium ${txtColor} opacity-90 mb-1`}>
          {title}
        </h3>
        <p className={`text-2xl font-bold ${txtColor}`}>
          {count}
        </p>
      </div>
      <div className={`
        p-3 rounded-full bg-primary bg-opacity-20
        flex items-center justify-center
        ${txtColor} text-xl
      `}>
        <DisplayIcon className="h-5 w-5 text-zinc-600" />
      </div>
    </div>
  );
};

export default Card;
